import { render, staticRenderFns } from "./PlanPreviewPrivate.vue?vue&type=template&id=1720bea2&scoped=true&lang=html&"
import script from "./PlanPreviewPrivate.vue?vue&type=script&lang=js&"
export * from "./PlanPreviewPrivate.vue?vue&type=script&lang=js&"
import style0 from "./PlanPreviewPrivate.vue?vue&type=style&index=0&id=1720bea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720bea2",
  null
  
)

export default component.exports